import { Skeleton, styled } from '@mui/material';

const StyledProgressGalleryThumbnailSkeleton = styled(Skeleton)(({ theme }) => ({
  borderRadius: '4px',
  height: '112px',
  [theme.breakpoints.up('md')]: {
    borderRadius: '5px'
  },
  [theme.breakpoints.up('lg')]: {
    height: '200px'
  }
}));

export default StyledProgressGalleryThumbnailSkeleton;
